module.exports = __webpack_public_path__ + "img/taoyuan-6.01978725.jpg";